import { inject, Injectable } from '@angular/core';
import { DeviceType, DeviceTypeService } from './device-type.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Breakpoint, lower } from '../utilities/breakpoint';


@Injectable({
  providedIn: 'root',
})
export class DeviceTypeBrowserService implements DeviceTypeService {

  private breakpointObserver = inject(BreakpointObserver);

  private getType(): DeviceType | undefined {
    if (this.breakpointObserver.isMatched(lower(Breakpoint.MediumSmall))) {
      return 'mobile';
    }
    return undefined;
  }

  public isMobile(): boolean | undefined {
    return this.getType() === 'mobile';
  }

}
